import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteSummaryForm} from "@/pages/Summary/WriteSummary";
import {SearchBO} from "@/service/common.s";
import {RecordPO, SummaryPO} from "@/model/content";

export enum SummaryEnum {
    GetSummaryPage = "/summary/getSummaryPage",
    GetSummary = "/summary/getSummary",
    CreateSummary = "/summary/createSummary",
    SearchSummary = "/summary/searchSummary",
    UpdateSummary = "/summary/updateSummary",
}

export interface SummaryPageBO {
    keyword?: string;
}

export interface SearchSummaryVO extends SummaryPO {
    id: number
}

export interface SummaryPageVO extends SummaryPO {
    avatar: string;
}

export interface SummaryVO extends SummaryPO {
    records: RecordPO[]
}

export const useQuerySummaryPage = () => useMutation<BaseVO<PaginationVO<SummaryPageVO>>, null, SummaryPageBO>({
    mutationFn: (data: SummaryPageBO) => http.post<BaseVO<PaginationVO<SummaryPageVO>>>({
        url: SummaryEnum.GetSummaryPage,
        data: data,
    }),
})

export const useQuerySummary = (params: GetByIdBO, enabled?: boolean) => useQuery<BaseVO<SummaryVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<SummaryVO>>({
        url: SummaryEnum.GetSummary,
        params: params
    }),
    enabled: enabled,
})

export const useCreateSummary = () => useMutation({
    mutationFn: (data: WriteSummaryForm) => http.put<BaseVO<null>>({url: SummaryEnum.CreateSummary, data}),
})

export const useUpdateSummary = () => useMutation({
    mutationFn: (data: WriteSummaryForm) => http.post<BaseVO<null>>({url: SummaryEnum.UpdateSummary, data}),
})

export const useSearchSummary = () => useMutation({
    mutationFn: (data: SearchBO) => http.post<BaseVO<SearchSummaryVO[]>>({url: SummaryEnum.SearchSummary, data})
})


